<script>
export default {
  props: {
    socialNetwork: {
      type: String,
      required: true,
    },

  },
}
</script>

<template>
<span>
  <div v-if="socialNetwork === 'instagram'" class="icon-wrap">
      <img src="@/assets/images/brands/instagram.png" class="img-fluid" alt="">
  </div>
  <i v-else-if="socialNetwork === 'facebook'" class="bx bxl-facebook-square facebook-color"
     style="vertical-align:middle;"></i>
  <i v-else-if="socialNetwork === 'youtube'" class="bx bxl-youtube youtube-color"
     style="vertical-align:middle;"></i>
  <i v-else-if="socialNetwork === 'blog'" class="fas fa-blog blog-color"
     style="vertical-align:middle; "></i>
</span>
</template>

<style scoped>
  .icon-wrap {
    height: 12px;
    width: 12px;
    display: inline-block;
    margin-right: 5px;
  }
</style>
